









import { Component, Vue } from 'vue-property-decorator'
import NotificationPage from '@/components/notification/Notification.vue'

@Component({
  components: { NotificationPage },
})
export default class Notification extends Vue {}
